var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 48,
    viewBox: "0 0 40 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4955_54911)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M27.9326 9.85141C26.8392 9.85035 25.7909 9.41555 25.0178 8.64241C24.2447 7.86928 23.8099 6.82099 23.8088 5.72762V0.00390662H5.38374C4.67683 0.00364393 3.97679 0.142653 3.32361 0.412993C2.67044 0.683332 2.07692 1.07971 1.57697 1.57947C1.07702 2.07924 0.680425 2.6726 0.409843 3.32568C0.13926 3.97875 -4.88096e-08 4.67873 0 5.38564V37.828C0.00211998 39.2543 0.570331 40.6214 1.5798 41.629C2.58928 42.6366 3.95745 43.2023 5.38374 43.2017H27.5026C28.93 43.2017 30.2988 42.6347 31.3081 41.6255C32.3173 40.6162 32.8843 39.2473 32.8843 37.82V9.85141H27.9326Z",
    fill: "#00678E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.8844 9.85141H27.9327C26.8393 9.85035 25.791 9.41555 25.0179 8.64241C24.2447 7.86928 23.8099 6.82099 23.8088 5.72762V0.00390625L32.8844 9.85141Z",
    fill: "#00678E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7882 34.1222H11.7814C10.0076 34.1222 8.56958 35.5602 8.56958 37.334V44.7897C8.56958 46.5635 10.0076 48.0015 11.7814 48.0015H36.7882C38.562 48.0015 40 46.5635 40 44.7897V37.334C40 35.5602 38.562 34.1222 36.7882 34.1222Z",
    fill: "#00678E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6671 42.6758V44.1297H15.1711V42.6758H16.6671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1867 38.158V44.1297H22.7308V40.4019L21.4388 44.1357H20.1709L18.871 40.3939V44.1357H17.415V38.164H19.193L20.8189 42.3238L22.4188 38.164L24.1867 38.158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6446 38.116V44.1297H25.1907V38.116H26.6446Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6784 42.6798C32.428 43.1345 32.0498 43.5058 31.5905 43.7477C31.0737 44.0123 30.499 44.1436 29.9186 44.1297H27.6487V38.116H29.9186C30.4995 38.1004 31.0753 38.2289 31.5945 38.49C32.0525 38.7267 32.4298 39.0943 32.6784 39.5459C32.9388 40.0254 33.0698 40.5644 33.0584 41.1099C33.0692 41.6572 32.9384 42.198 32.6784 42.6798ZM31.1145 42.3778C31.2771 42.2109 31.403 42.012 31.4843 41.7936C31.5656 41.5753 31.6004 41.3424 31.5865 41.1099C31.6002 40.8773 31.5654 40.6445 31.4841 40.4262C31.4029 40.2078 31.277 40.0089 31.1145 39.8419C30.7494 39.5239 30.2738 39.3623 29.7906 39.392H29.1026V42.8278H29.7906C30.2738 42.8574 30.7494 42.6958 31.1145 42.3778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0448 26.3866H21.8549V17.535C21.8549 17.2385 21.7371 16.9542 21.5274 16.7445C21.3178 16.5349 21.0334 16.4171 20.7369 16.4171H15.1372C14.8405 16.4171 14.556 16.5348 14.346 16.7444C14.136 16.954 14.0178 17.2384 14.0173 17.535V26.3866H11.8174V16.7871C11.8179 16.1069 12.0885 15.4548 12.5696 14.974C13.0508 14.4933 13.7031 14.2232 14.3833 14.2232H21.4649C22.1449 14.2232 22.797 14.4933 23.2778 14.9741C23.7587 15.455 24.0288 16.1071 24.0288 16.7871L24.0448 26.3866Z",
    fill: "#00678E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4489 28.9824C22.8826 28.9824 24.0448 27.8202 24.0448 26.3866C24.0448 24.9529 22.8826 23.7907 21.4489 23.7907C20.0152 23.7907 18.853 24.9529 18.853 26.3866C18.853 27.8202 20.0152 28.9824 21.4489 28.9824Z",
    fill: "#00678E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4355 28.9824C12.8691 28.9824 14.0313 27.8202 14.0313 26.3866C14.0313 24.9529 12.8691 23.7907 11.4355 23.7907C10.0018 23.7907 8.8396 24.9529 8.8396 26.3866C8.8396 27.8202 10.0018 28.9824 11.4355 28.9824Z",
    fill: "#00678E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4955_54911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 47.9976,
    fill: "white",
    transform: "translate(0 0.00390625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMid);
export default __webpack_public_path__ + "static/media/mid.fa2929618028d2f183ff30177cfdea8a.svg";
export { ForwardRef as ReactComponent };